import React, { Component } from 'react'
import styled from 'styled-components'
import { vw } from '../untils/styled'

const Wrapper = styled.div`
  width: 100%;
  text-align: center;
`

const Main = styled.div`
  font-size: ${vw(38)};
  color: #fffcf7;
  opacity: 0.6;
  position: relative;

  span {
    display: inline-block;
    vertical-align: middle;
  }

  > span:first-of-type {
    width: ${vw(50)};
    height: ${vw(4)};
    background-image: linear-gradient(90deg, transparent 0%, #cdcbc8 100%);
    opacity: 0.6;
  }
  > span:nth-of-type(2) {
    margin: 0 ${vw(17)};
  }

  > span:last-of-type {
    width: ${vw(50)};
    height: ${vw(4)};
    background-image: linear-gradient(90deg, #cdcbc8 0%, transparent 100%);
    opacity: 0.6;
  }

  /* &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: ${vw(170)};
    width: ${vw(50)};
    height: ${vw(4)};
    background-image: linear-gradient(90deg, #cdcbc8 0%, transparent 100%);
    opacity: 0.6;
  }
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: ${vw(170)};
    width: ${vw(50)};
    height: ${vw(4)};
    background-image: linear-gradient(90deg, transparent 0%, #cdcbc8 100%);
    opacity: 0.6;
  } */
`

const Sub = styled.div`
  font-size: ${vw(20)};
  color: #fff;
  opacity: 0.4;
`

export default class Title extends Component {
  render() {
    return (
      <Wrapper>
        <Main>
          <span></span>
          <span>{this.props.mainTitle}</span>
          <span></span>
        </Main>
        <Sub>{this.props.subTitle}</Sub>
      </Wrapper>
    )
  }
}
